import React, { useEffect, useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useFormik } from "formik";
import "primereact/resources/themes/lara-light-indigo/theme.css";
import "primereact/resources/primereact.min.css";
import { Toast } from "primereact/toast";

import { getUserProfileDetail, getUserProfileUpdate } from "../../api";
import { useSelector } from "react-redux";
import { ProfileSettingSchema } from "../../schema";

const AddProfile = ({ id }) => {
  const { profileData, token } = useSelector((state) => state.profileReducer);
  const [user, setUser] = useState();
  const toast = useRef(null);
  const [isLoading, setIsLoading] = useState(false);
  const [isAgentTelephoneInput, setIsAgentTelephone] = useState(false);
  // const [profile, setProfile] = useState();
  const [serviceData, setServiceData] = useState(null);
  const [previewImg, setPreviewImg] = useState(null);
  const [image1, setImage] = useState(null);
  const [blankErrFn, setBlankErrFn] = useState(false);
  const [blankErrLn, setBlankErrLn] = useState(false);

  const initialValues = {
    profile_pic: user ? user?.profile_pic : "",
    email: user ? user?.email : "",
    firstName: user ? user?.first_name : "",
    lastName: user ? user?.last_name : "",
    gender: user ? user?.gender : "",
    telephone: user ? user?.telephone : "",
  };

  const onChangeHandler = (e) => {
    setBlankErrFn(false);
    setFieldValue("firstName", e);
  };
  const onHandlerChange = (ev) => {
    setBlankErrLn(false);
    setFieldValue("lastName", ev);
  };
  const editProfileHandler = async (values) => {
    let isError = false;
    if (values.firstName.trim() === "") {
      setBlankErrFn(true);
      isError = true;
    }
    if (values.lastName.trim() === "") {
      setBlankErrLn(true);
      isError = true;
    }
    if (isError) return;
    if (!blankErrFn && !blankErrLn) {
      const formData = new FormData();
      if (image1) formData.append("profile_pic", image1);
      formData.append("first_name", values.firstName.trim());
      formData.append("last_name", values.lastName.trim());
      formData.append("gender", values.gender);
      formData.append("telephone", values.telephone);

      getUserProfileUpdate(profileData?.id, formData, token)
        .then((res) => {
          setUser(res?.data?.result);
          setIsLoading(true);
          toast.current.show({
            severity: "success",
            summary: `${res?.data?.message}`,
          });
          setTimeout(() => {
            navigate(-1);
          }, 1000);
        })
        .catch((err) => {
          setIsLoading(false);
          toast.current.show({
            severity: "error",
            summary: `${err?.response?.data?.message}`,
          });
        });
    }
  };

  const getProfiledata = () => {
    getUserProfileDetail(token)
      .then((res) => {
        // toast.current.show({
        //   severity: "success",
        //   summary: `${res?.data?.message}`,
        // });
        setPreviewImg(res?.data?.result?.profile_pic);
        setServiceData(res?.data?.result);
        setUser(res?.data?.result);
      })
      .catch((err) => {});
  };
  const {
    values,
    errors,
    handleChange,
    handleSubmit,
    touched,
    setFieldValue,
    // setFieldTouched,
    handleBlur,
  } = useFormik({
    enableReinitialize: true,
    initialValues,
    validationSchema: ProfileSettingSchema(isAgentTelephoneInput),
    onSubmit: (values) => editProfileHandler(values),
  });

  useEffect(() => {
    async function getAllAPI() {
      getProfiledata();
    }
    getAllAPI();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const checkFileFormat = (file) => {
    const fileName = file.name;

    // Define a regular expression to match allowed file formats/extensions
    const allowedFormats = /\.(jpg|jpeg|png)$/i;

    // Test if the file name matches the allowed formats
    if (allowedFormats.test(fileName)) {
      return true; // File format is allowed
    } else {
      return false; // File format is not allowed
    }
  };

  const handleImageUpload = (e, setImage) => {
    const file = e.target.files[0];
    if (e.target.files.length && checkFileFormat(file)) {
      setImage(file);
      const reader = new FileReader();
      reader.onload = () => {
        setPreviewImg(reader.result);
        setFieldValue("image", file);
      };
      reader.readAsDataURL(file);
    } else {
      e.target.value = null;
      toast.current.show({
        severity: "error",
        summary: `Please Upload the Image file only`,
      });
    }
  };

  // const onsaveimage = async (id) => {
  //   const formData = new FormData();
  //   if (image1) formData.append("profile_pic", image1);
  //   await getUserProfileUpdate(
  //     id,
  //     formData,
  //     token
  //     // {
  //     //   userId: serviceData?.userId
  //     //     .split(",")
  //     //     .filter((ele) => ele !== Userid)
  //     //     .join(),
  //     //     image: image1
  //     // },
  //   )
  //     .then((res) => {
  //       setIsLoading(false);
  //       toast.current.show({
  //         severity: "success",
  //         summary: `${res?.data?.message}`,
  //       });
  //       setTimeout(() => {
  //         // navigate("event-management/EventDetails");
  //       }, 2000);
  //     })
  //     .catch((err) => {
  //       setIsLoading(false);
  //       toast.current.show({
  //         severity: "error",
  //         summary: `${err?.response?.data?.message}`,
  //       });
  //     });
  // };

  const onAgentTeleChange = (tele) => {
    setFieldValue("telephone", tele);
    setIsAgentTelephone(true);
  };

  const navigate = useNavigate();

  return (
    <>
      <Toast ref={toast} />

      {isLoading && (
        <div className="set-proper-line-in-all-page">
          <div className="spinner-border" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
        </div>
      )}
      <div className="news-details-cls-portion mt-4">
        <form onSubmit={handleSubmit} className="">
          <div className="event-details-all-starting-part">
            <div className="userprofile-pics">
              {/* <div className="change-profile-cls"> */}
              <div className="d-flex align-items-center">
                <svg
                  width="32"
                  height="24"
                  viewBox="0 0 32 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  onClick={() => {
                    navigate(-1);
                  }}
                >
                  <path
                    d="M0.93934 10.9393C0.353553 11.5251 0.353553 12.4749 0.93934 13.0607L10.4853 22.6066C11.0711 23.1924 12.0208 23.1924 12.6066 22.6066C13.1924 22.0208 13.1924 21.0711 12.6066 20.4853L4.12132 12L12.6066 3.51472C13.1924 2.92893 13.1924 1.97919 12.6066 1.3934C12.0208 0.807611 11.0711 0.807611 10.4853 1.3934L0.93934 10.9393ZM2 13.5H32V10.5H2V13.5Z"
                    fill="black"
                  />
                </svg>
                <h6 className="mb-0 ">Change Profile</h6>
              </div>
            </div>

            <div className="main-profile-all-cls-start mt-4">
              <div className="details-all-name upload-user-profile-cls">
                <div className="row">
                  <div className="col-lg-4 position-relative">
                    <label className="my-2">
                      Upload image:-{" "}
                      {/* <span className="required">
                        {" "}
                        Upload the Image (300w X 280h)
                      </span> */}
                    </label>
                    <div className="left-side-img">
                      {previewImg && serviceData && (
                        <div className="text-centersall">
                          <img
                            src={
                              previewImg
                                ? previewImg
                                : require("../../assets/defaultImg.png")
                            }
                            alt="Preview1"
                          />
                        </div>
                      )}
                    </div>

                    <div className="mt-4">
                      <input
                        type="file"
                        name="profile_pic"
                        className="form-control set-to-auto-height"
                        accept="image/png, image/jpeg, image/jpg , image/bmp"
                        id="exampleFormControlInput1"
                        placeholder="File Name"
                        onBlur={handleBlur}
                        onChange={(e) => handleImageUpload(e, setImage)}
                      />
                      {errors.profile_pic && touched.profile_pic ? (
                        <p className="form-error">{errors.profile_pic}</p>
                      ) : null}
                      <span className="upload-all-btns-cls-add"></span>
                    </div>
                  </div>
                  <div className="col-lg-4">
                    <label className="my-2">First name</label>
                    <input
                      type="text"
                      className="form-control"
                      name="firstName"
                      id="exampleFormControlInput2"
                      placeholder="Write here"
                      value={values.firstName}
                      onChange={(e) => onChangeHandler(e.target.value)}
                      onBlur={handleBlur}
                    />{" "}
                    {errors.firstName && touched.firstName ? (
                      <p className="form-error">{errors.firstName}</p>
                    ) : null}
                    {blankErrFn && (
                      <p className="form-error">White-space not allowed</p>
                    )}
                  </div>
                  <div className="col-lg-4">
                    <label className="my-2">Last Name</label>
                    <input
                      type="text"
                      className="form-control"
                      name="lastName"
                      id="exampleFormControlInput3"
                      placeholder="Enter Last Name"
                      value={values.lastName}
                      onChange={(ev) => onHandlerChange(ev.target.value)}
                      onBlur={handleBlur}
                    />
                    {errors.lastName && touched.lastName ? (
                      <p className="form-error">{errors.lastName}</p>
                    ) : null}
                    {blankErrLn && (
                      <p className="form-error">White-space not allowed</p>
                    )}
                  </div>
                </div>

                <div className="row mt-4">
                  <div className="col-lg-4">
                    <label className="my-2">Gender</label>
                    <select
                      name="gender"
                      value={values.gender}
                      className="form-select"
                      aria-label="Default select example"
                      onChange={handleChange}
                      placeholder="Select Gender"
                    >
                      <option value="" disabled hidden>
                        Select Gender
                      </option>
                      <option value="1" label="Male">
                        Male
                      </option>
                      <option value="2" label="Female">
                        Female
                      </option>
                      <option value="3" label="Non-Binary">
                        Non-Binary
                      </option>
                    </select>
                  </div>
                  <div className="col-lg-4">
                    <label className="my-2">Email</label>
                    <input
                      type="text"
                      className="form-control"
                      name="email"
                      disabled
                      id="exampleFormControlInput2"
                      placeholder="Enter Your Email"
                      value={values.email}
                      onChange={handleChange}
                      onBlur={handleBlur}
                    ></input>
                  </div>
                  <div className="col-lg-4">
                    <label className="my-2">Phone</label>
                    <input
                      type="number"
                      name="telephone"
                      className="form-control"
                      id="exampleFormControlInput3"
                      placeholder="Telephone"
                      value={values.telephone}
                      onChange={(e) => {
                        onAgentTeleChange(e.target.value);
                      }}
                    ></input>
                    {errors.telephone && touched.telephone ? (
                      <p className="form-error">{errors.telephone}</p>
                    ) : null}
                  </div>
                </div>

                <div className="row mt-4">
                  <div className="col-lg-12">
                    <div className="right-sidebtn-add text-end">
                      <div className="d-flex align-items-center justify-content-end">
                        <button
                          type="button"
                          className="btn btn-primary outline-btn-cls me-3"
                          onClick={() => {
                            navigate(-1);
                          }}
                        >
                          Cancel
                        </button>
                        <button
                          type="submit"
                          className="btn btn-primary filled-btn-cls"
                        >
                          Save
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
    </>
  );
};

export default AddProfile;
